<template>
  <v-dialog
      persistent
      v-model="exibir"
  >
    <v-card class="pb-1">
      <v-card-title>
        <span>Desativar Sub Login</span>
        <v-btn
            icon
            class="ml-auto"
            @click="fechar"
        >
          <v-icon
              size="10"
              color="primaria"
          >
            pc-fechar
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>Tem certeza que deseja desativar o sub login?</v-card-text>
      <v-card-actions>
        <v-spacer />
        <Button
            small
            outlined
            @click="fechar"
        >
          Cancelar
        </Button>
        <Button
            small
            @click="desativarSublogin"
        >
          Continuar
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import { desativarSublogin } from '@/service/sublogin'

  export default {
    props: {
      login: String,
      exibir: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      async desativarSublogin () {
        try {
          const { mensagem } = await desativarSublogin(this.login)
          this.$router.go(-1)
          this.$toast.success(mensagem)
        } catch (erro) {
          this.$toast.error(erro)
        }
      },
      fechar () {
        this.$emit('exibir', false)
      }
    }
  }

</script>
